export default __webpack_public_path__ + "static/media/gallery_08.d99e0bbb.jpg";